// extracted by mini-css-extract-plugin
export default {"wwdTilesSection":"WhatWeDo_wwdTilesSection__gMD6R","wwdTilesDivider":"WhatWeDo_wwdTilesDivider__Bl7E-","wwdContentBanner":"WhatWeDo_wwdContentBanner__thaV9"};